module.exports = __webpack_public_path__ + "static/media/jsicon-orange.17ddb639.png";